import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { GetActiveAbsencesQuerySchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { client } from "@/hono";

export function useUserAbsences(
	userId: string,
	query?: GetActiveAbsencesQuerySchema,
	year?: number,
) {
	const _query = useQuery({
		queryKey: ["user", "absences", userId, JSON.stringify(query || {}), guardString(year)],
		queryFn: async () => {
			const response = await client.users[":userId"].absences.$get({
				param: { userId },
				query: { ...(query || {}), ...(year !== undefined ? { year: guardString(year) } : {}) },
			});
			const data = await responseHandler(response);
			return data;
		},
	});

	return {
		..._query,
		upcoming: guardArray(_query.data?.upcoming),
		past: guardArray(_query.data?.past),
		absences: guardArray(_query.data?.absences),
		current: guardArray(_query.data?.current),
	};
}
